import { __assign, __generator } from "tslib";
import { select, fork, take, put, all } from 'redux-saga/effects';
import i18n from 'i18next';
import ddt from '@wix/da-ddt';
import { reloadStashStream, reloadStashStreamDone } from '../actions';
import { getCurrentFolderId } from '../selectors';
import { uploadFileHandler } from './uploadFile';
import { getAllUploads } from '../../redux/uploads/selectors';
var MAX_CONCURRENT_UPLOADS_ALLOWED = 10;
function uploadFilesSaga(action) {
    var allUploads, activeUploads, newFileUploads, remainingUploadSlots, currentFolderId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getAllUploads)];
            case 1:
                allUploads = _a.sent();
                activeUploads = allUploads.filter(function (item) {
                    return item.hasOwnProperty('progress');
                });
                newFileUploads = action.payload;
                remainingUploadSlots = Math.max(0, MAX_CONCURRENT_UPLOADS_ALLOWED - activeUploads.length);
                if (remainingUploadSlots < newFileUploads.length) {
                    ddt.error('MediaManager', 'Maximum concurrent file uploads exceeded. Truncating...', newFileUploads.slice(remainingUploadSlots));
                    alert(i18n.t('mediapopup.upload.error.maxConcurrentUploadsExceeded', {
                        count: MAX_CONCURRENT_UPLOADS_ALLOWED,
                    }));
                }
                return [4 /*yield*/, put(reloadStashStream())];
            case 2:
                _a.sent();
                return [4 /*yield*/, take(reloadStashStreamDone)];
            case 3:
                _a.sent(); // wait for reload to complete
                return [4 /*yield*/, select(getCurrentFolderId)];
            case 4:
                currentFolderId = _a.sent();
                return [4 /*yield*/, all(newFileUploads.slice(0, remainingUploadSlots).map(function (payload) {
                        var folderId = payload.folderId || currentFolderId;
                        return fork(uploadFileHandler, __assign(__assign({}, payload), { folderId: folderId }));
                    }))];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default uploadFilesSaga;
//# sourceMappingURL=uploadFiles.js.map